<template lang='pug'>
  r-form(
    ref='form'
    submit-text='enviar pago'
    v-bind='formProps'
    v-model='formData'
    @submit='submitCreate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import Translator from '@/services/translator'
  //
  import ProviderPaymentModel from '@/models/Purchase/PchProviderPayment'
  import ProviderPaymentFields from '@/views/Purchase/PchProviderPayment/PchProviderPaymentFields'
  //
  export default {
    components: {
      RForm,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      fieldsProps() {
        return {
          pch_provider_id: this.formData.pch_provider_id,
          raw_payments_method: this.submitAdd,
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      formProps () {
        return {
          fields: ProviderPaymentFields(this.fieldsProps),
        }
      },
    },
    data() {
      return {
        formData: new ProviderPaymentModel({ 
          pch_provider_id: '',
          raw_debt_to_pays: [],
          raw_payments: [],
        })
      }
    },
    methods: {

      /**
       * { function_description }
       */
      redirect() {
        this.$router.push({ name: 'provider-payment-list' })
      },

      /**
       * Resets the object.
       */
      reset() {
        //this.formData.pch_provider_id = null
        this.formData.raw_debt_to_pays = []
        this.formData.raw_payments = []
        this.formData.debt_to_pays = []
        this.formData.payments = []
      },

      /**
       * Shows the error.
       *
       * @param      {<type>}  error   The error
       * @return     {<type>}  { description_of_the_return_value }
       */
      showError(error) {
        return this.showErrorSnackbar(Translator(ProviderPaymentModel, error.response.data))
      },

      /**
       * Shows the success create.
       *
       * @return     {<type>}  { description_of_the_return_value }
       */
      showSuccessCreate() {
        return this.showSuccessSnackbar('Pago enviado exitosamente.')
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitAdd(event) {

        //
        let posPaymentTypeId  = event.pos_payment_type.id
        let isEffective = posPaymentTypeId === 1
        let isCheck     = posPaymentTypeId === 4
        let isTransfer  = posPaymentTypeId === 6

        //
        this.formData.raw_payments.push({
          ...event,
          id                          : this.formData.raw_payments.length,
          g_bank_bank                 : isEffective ? '-' : event.g_bank.bank,
          // g_bank_bank                 : event.pos_payment_type.id !== 4 ? '-' : event.g_bank.bank,
          account                     : isEffective ? '-' : event.account_number,
          account_number              : isEffective ? '-' : event.account_number,
          // account_number              : event.pos_payment_type.id !== 4 ? '-' : event.account_number,
          plaza                       : isCheck ? event.plaza : '-',
          // plaza                       : event.pos_payment_type.id !== 4 ? '-' : event.plaza,
          pos_payment_check_type      : isCheck ? event.pos_payment_check_type : '-',
          // pos_payment_check_type      : event.pos_payment_type.id !== 4 ? '-' : event.pos_payment_check_type,
          pos_payment_check_type_text : isCheck ? event.pos_payment_check_type.text : '-',
          // pos_payment_check_type_text : event.pos_payment_type.id !== 4 ? '-' : event.pos_payment_check_type.text,
          charge_date                 : isCheck ? event.charge_date : '-',
          // charge_date                 : event.pos_payment_type.id !== 4 ? '-' : event.charge_date,
          serial_number               : isCheck ? event.serial_number : '-',
          // serial_number               : event.pos_payment_type.id !== 4 ? '-' : event.serial_number,
          payment_type                : isCheck ? 'Cheque' : isEffective ? 'Efectivo' : 'Transferencia',
          // payment_type                : event.pos_payment_type.id !== 4 ? event.pos_payment_type.id !== 6 ? 'Efectivo' : 'Transferencia' : 'Cheque',
        })

        //
        this.$refs.form.getInput('raw_payments').$refs.toolbar.$refs.formAdder.close()
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitCreate(event) {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.toWait)
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  model   The model
       * @return     {<type>}  { description_of_the_return_value }
       */
      toCreate(model) {
        return model
          .toCreate()
          .save()
          .then(this.showSuccessCreate)
          .then(this.redirect)
          .catch(this.showError)
      },

      /**
       * { function_description }
       *
       * @param      {boolean}  [value=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      toWait(value = false) {
        return this
          .$refs
          .form
          .setWait(value)
      },
    },
    beforeMount () {
      this.setTitle('Crear pago de proveedor')
    },
  }
</script>